import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/context';

interface ProtectedRouteProps {
  component: React.ComponentType;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component
}) => {
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn()) {
    return <Navigate to="/" />;
  }

  return <Component />;
};

export default ProtectedRoute;
